import * as Sentry from "@sentry/react";

type SentryTagValue = string | number | boolean | null | undefined;

export const setSentryTag = (name: string, value: SentryTagValue): void => {
  if (typeof window === "undefined") {
    return;
  }

  if (value === null || value === undefined || value === "") {
    Sentry.setTag(name, undefined);
    Sentry.getIsolationScope().removeAttribute(name);
    return;
  }

  Sentry.setTag(name, String(value));
  Sentry.setAttribute(name, value);
};
